import { memo, useCallback, useEffect, useMemo, useState } from 'react';

// material-ui
import { Grid } from '@mui/material';

import NetworkAppsService from 'services/network-apps/NetworkApps';
import PlanFilters from 'modules/networksapps/PlanFilters';
import DataComponent from 'modules/networksapps/DataComponent';
import { SvgIcon } from '@mui/material';
import { ReactComponent as PublicIcon } from 'assets/icons/assign_public_icon.svg';
import { ReactComponent as PrivateIcon } from 'assets/icons/assign_private_icon.svg';
import { AssignButtonContainer } from 'modules/onechip-details/meerkat/containers/AssignContainer';
import LoadingButton from '@mui/lab/LoadingButton';
import { useModal } from 'components/shared/modal';

import PlanDetailsContainer from 'modules/modals/PlanDetails/containers/PlanDetailsContainer';
import InfinityScrollWrapper from 'modules/modals/SelectPlan/components/InfinityScrollContainer';
import useStateAsync from 'hooks/useStateAsync';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SharedSelectPlan from 'modules/modals/SelectPlan/containers/SharedSelectPlan';
import useBulkSelectPlan from 'modules/modals/SelectPlan/hooks/useBulkSelectPlan';

const BulkMeerkatSelectPlan = ({ queryFilters }) => {
  const modal = useModal({ stacked: false });

  const { t } = useTranslation();

  const { meerkatPrivateVpnEnabled = false, meerkatPublicVpnEnabled = false } = useSelector(
    (state) => state.account.selected
  );
  const additionPlanParams = {
    meerkatPrivateVpnEnabled,
    meerkatPublicVpnEnabled,
  };

  const preselect = () => {
    return {
      service: [
        {
          label: 'Meerkat',
          value: 'meerkat',
        },
      ],
    };
  };

  const readOnly = {
    service: true,
  };

  const handleOpenPlanDetailsModal = (data) => {
    modal.openModal(
      PlanDetailsContainer,
      {
        data,
        isMeerkat: true,
        queryFilters,
      },
      {
        title: [
          { name: 'BulkMeerkatPlanSelectionModal', title: t('views.onechip_details.meerkat.actions.add_app') },
          { name: '', title: data.planName },
        ],
        fullWidth: true,
        maxWidth: 'md',
        close: true,
        sx: {
          '& .ModalContentWrapper-root': {
            backgroundColor: '#F5F5F5',
          },
        },
      }
    );
  };

  return (
    <SharedSelectPlan
      readOnly={readOnly}
      preselect={preselect}
      onPlanOpen={handleOpenPlanDetailsModal}
      usePlanList={useBulkSelectPlan}
    >
      {(plan) => (
        <>
          <AssignButtonContainer modal={modal} key={'public'} data={{ ...additionPlanParams, ...plan }} type="public">
            {({ onAssign, isLoadingAssign }) => (
              <LoadingButton
                variant="contained"
                fullWidth
                startIcon={<SvgIcon component={PublicIcon} inheritViewBox />}
                onClick={(event) => onAssign(event, queryFilters)}
                loading={isLoadingAssign}
                disabled={isLoadingAssign}
              >
                Assign Public IP
              </LoadingButton>
            )}
          </AssignButtonContainer>
          <AssignButtonContainer modal={modal} key={'private'} data={{ ...additionPlanParams, ...plan }} type="private">
            {({ onAssign, isLoadingAssign }) => (
              <LoadingButton
                variant="outlined"
                fullWidth
                startIcon={<SvgIcon component={PrivateIcon} sx={{ fill: 'none' }} inheritViewBox />}
                onClick={(event) => onAssign(event, queryFilters)}
                loading={isLoadingAssign}
                disabled={isLoadingAssign}
              >
                Assign Private IP
              </LoadingButton>
            )}
          </AssignButtonContainer>
        </>
      )}
    </SharedSelectPlan>
  );
};

export default BulkMeerkatSelectPlan;
